import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Modal,
  ModalBody,
  FormGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Spinner } from "components/Icons/Spinner";
import CardFooter from "reactstrap/lib/CardFooter";
import { useSelector } from "react-redux";
import Select from "react-select";

var Utils = require("Utils");
var Const = require("Const");

var searchApi = require("../../search/api");

export const EnrollRequirement = ({ req, upload, zoom, deleteFile }) => {
  const { token, isDeleting } = useSelector((state) => ({
    token: state.auth.session.jwt_token,
    isDeleting:
      state.view.loadingModules["deleteEnrollFile" + req.enroll_persona_file],
  }));

  return (
    <>
      <Col md="3">
        <Card style={{ height: "15rem" }}>
          <CardHeader>
            <span className="h6">{req.title}</span>
            {req.mandatory === "Y" && <b> (*)</b>}
            <br />
            <span className="">{req.description}</span>
          </CardHeader>
          <CardBody>
            {req.enroll_persona_file && (
              <img
                src={req.thumbnail_url}
                alt={req.thumbnail_url}
                height="70%"
                onClick={() => {
                  zoom(true, req);
                }}
                style={{ cursor: "zoom-in" }}
              />
            )}
          </CardBody>
          <CardFooter>
            {req.enroll_persona_file ? (
              <>
                <Button
                  color="success"
                  size="sm"
                  onClick={() => upload(true, req)}
                >
                  Agregar otra
                </Button>
                &nbsp;
                <Button
                  color="danger"
                  size="sm"
                  disabled={isDeleting}
                  onClick={() =>
                    deleteFile(
                      token,
                      req.persona_id,
                      req.req_id,
                      req.enroll_persona_file,
                    )
                  }
                >
                  {isDeleting ? (
                    <i className="nc-icon nc-refresh-69  fa-spin" />
                  ) : (
                    <>
                      <span className="btn-label">
                        <i className="fa fa-floppy-o" aria-hidden="true"></i>
                      </span>
                      Eliminar
                    </>
                  )}
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="success"
                  size="sm"
                  onClick={() => upload(true, req)}
                >
                  Agregar
                </Button>
              </>
            )}
          </CardFooter>
        </Card>
      </Col>
    </>
  );
};

export const EnrollHeader = ({ persona, course, enrollStudentCourse }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [courses, setCourses] = useState();
  const [asgCourse, setAsgCourse] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState();

  const { token, isSaving } = useSelector((state) => ({
    token: state.auth.session.jwt_token,
    isSaving: state.view.loadingModules["enrollStudentCourse"],
  }));

  const enrollCourse = async () => {
    setAsgCourse(true);
    let dev = await searchApi.getCourses(
      token,
      "20270000-5026-4B33-9EAA-000000002027",
    );
    setCourses(
      dev.map((c) => {
        return {
          value: c.course_id,
          label:
            c.top_name +
            " - " +
            c.name +
            " Turno " +
            c.shift_name +
            " (" +
            c.level_id.slice(-4) +
            ")",
        };
      }),
    );
    setAsgCourse(false);
    setModalOpen(!modalOpen);
  };
  const handleInputChangeSelect = (value) => {
    setSelectedCourse(value);
  };
  const confirmEnroll = async () => {
    enrollStudentCourse(token, persona.persona_id, selectedCourse.value);
  };

  return (
    <>
      <Modal
        toggle={() => setModalOpen(!modalOpen)}
        isOpen={modalOpen && (!course || !course.course_id)}
        size="lg"
      >
        <ModalBody>
          <FormGroup>
            <label>Alumno</label>
            <Select
              className="select-subject"
              name="course_id"
              isSearchable={true}
              onChange={handleInputChangeSelect}
              options={courses}
              placeholder="buscar curso..."
            />

            {selectedCourse && (
              <>
                <Button
                  color="success"
                  size="sm"
                  disabled={isSaving}
                  onClick={() => confirmEnroll()}
                >
                  {isSaving ? (
                    <i className="nc-icon nc-refresh-69  fa-spin" />
                  ) : (
                    <>
                      <span className="btn-label">
                        <i className="fa fa-floppy-o" aria-hidden="true"></i>
                      </span>
                      Confirmar curso
                    </>
                  )}
                </Button>
              </>
            )}
            <Button
              color="warning"
              size="sm"
              onClick={() => setModalOpen(!modalOpen)}
            >
              Cancelar
            </Button>
          </FormGroup>
        </ModalBody>
      </Modal>

      <Col md="12">
        <Card>
          <CardHeader>
            {persona.persona_id ? (
              <>
                <Row>
                  <Col md="2">
                    <img
                      alt="..."
                      className="avatar-new "
                      src={
                        persona.image
                          ? persona.image
                          : Const.DEFAULT_IMAGE_PROFILE[
                              persona.gender ? persona.gender : "O"
                            ]
                      }
                    />
                  </Col>
                  <Col md="5s">
                    <h5 className="title text-success">
                      {Utils.capitalize(
                        persona.last_name + ", " + persona.name,
                      )}
                    </h5>
                  </Col>
                  <Col md="5">
                    <div width="100%" className="float-right">
                      {course && course.course_id ? (
                        <>
                          <h5>
                            Curso:{" "}
                            <Link to={"/admin/course/" + course.course_id}>
                              {" "}
                              {course.name}{" "}
                            </Link>{" "}
                          </h5>
                        </>
                      ) : (
                        <>
                          {asgCourse ? (
                            <Button disabled={true}>
                              <i className="nc-icon nc-refresh-69  fa-spin" />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => {
                                enrollCourse();
                              }}
                            >
                              Asignar curso
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <Spinner size="L" />
            )}
          </CardHeader>
        </Card>
      </Col>
    </>
  );
};
